// performance-monitor.module.ts
import { NgModule } from '@angular/core';
import {PerformanceMonitorComponent} from './performance-monitor.component'
@NgModule({
  declarations: [PerformanceMonitorComponent],
  imports: [],
  exports: [PerformanceMonitorComponent],
})
export class PerformanceMonitorModule {}
